import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./Link.styled";
export const Link = forwardRef((props, ref) => {
    const { children, ...otherProps } = props;
    return (_jsx(Styled.Link, { "data-testid": "Link", ref: ref, 
        /* Casting "as" as undefined to work around for https://github.com/DefinitelyTyped/DefinitelyTyped/issues/30117 */
        as: (otherProps.href === undefined ? "button" : undefined), ...otherProps, children: children }));
});
Link.displayName = "Link";
